<template>
  <az-table :data="table.data" />
</template>

<script>
import AzTable from '@/components/AZTable';

export default {
  name: 'main-table',
  components: { AzTable },
  props: ['data', 'lease'],

  data() {
    return {
      table: {
        data: [
          ['Precio Esperado', this.formatNumber(this.data['precio_referencia']) + ' USD/t', 0],
          ['Rinde Esperado', this.formatNumber(this.data['rinde_presupuestado']) + ' qq/ha', 0],
          ['Ingreso Bruto', this.formatNumber(this.data['ingreso_bruto']) + ' USD/ha', 1],
          ['Gastos Comerciales', this.formatNumber(this.data['gastos_comerciales']) + ' USD/ha', 0],
          ['Ingreso Neto', this.formatNumber(this.data['ingreso_neto']) + ' USD/ha', 1],
          ['Insumos', this.formatNumber(this.data['insumos']) + ' USD/ha', [
            ['Semillas', this.formatNumber(this.data['Insumo_Sem'] ?? '-') + ' USD/ha'],
            ['Herbicidas', this.formatNumber(this.data['Insumo_Herb'] ?? '-') + ' USD/ha'],
            ['Insecticidas', this.formatNumber(this.data['Insumo_Insec'] ?? '-') + ' USD/ha'],
            ['Fungicida', this.formatNumber(this.data['Insumo_Fung'] ?? '-') + ' USD/ha'],
            ['Fertilizante', this.formatNumber(this.data['Insumo_Fert'] ?? '-') + ' USD/ha'],
          ], 0],
          ['Labores', this.formatNumber(this.data['labores']) + ' USD/ha', 0],
          ['Gerenciamiento', this.formatNumber(this.data['gerenciamiento']) + ' USD/ha', 0],
          ['Cosecha', this.formatNumber(this.data['cosecha']) + ' USD/ha', 0],
          ['Margen Bruto', this.formatNumber(this.data['margen_bruto']) + ' USD/ha', 1],
          (this.lease)
            ? ['Arrendamiento', this.formatNumber(this.data['arrendamiento']) + ' USD/ha', 0]
            : ['', '', 0],
          ['Margen Neto', this.formatNumber(this.data['margen_neto']) + ' USD/ha', 1],
        ]
      }
    }
  },

  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '-'
      const num = Number(value)
      if (Number.isNaN(num)) return value

      const isInt = Number.isInteger(num)
      return new Intl.NumberFormat('es-AR', {
        minimumFractionDigits: isInt ? 0 : 1,
        maximumFractionDigits: isInt ? 0 : 1
      }).format(num)
    }
  },
};
</script>